module.exports = __webpack_public_path__ + "img/Choca Mocha.5c98e025.png";